import script from "./DocsPreviewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsPreviewer.vue?vue&type=script&setup=true&lang=js"

import "./DocsPreviewer.vue?vue&type=style&index=0&id=01455269&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01455269"]])

export default __exports__